<template>
	<div class="ui fluid container fc-myinfo">
		<div class="fc-banner">
			<div class="ui container">
				<div class="fc-crumbs">
					<router-link :to="`${this.RouterConfig.Home}`">Home</router-link>
					&gt;
					<span>Account Profile</span>
				</div>
				<div class="fc-title" v-if="info != null && info != undefined">
					Hi, {{ info.FullName }}
				</div>
			</div>
		</div>
		<div class="ui container fc-content">
			<div>
				<left-nav />
			</div>
			<div class="fc-content-right">
				<info 
						v-if="!editingDetail && !changeingPassword && !editingAddress" 
						v-on:editDetail="editingDetail = true"
						v-on:changePassword="changeingPassword = true"
						v-on:editAddress="editAddress" />
				<editdetail v-if="editingDetail" v-on:closeEditDetail="editingDetail = false" />
				<change-password v-if="changeingPassword" v-on:closeEditDetail="changeingPassword = false" />
				<edit-address v-if="editingAddress" :keyId="editingAddressId" v-on:close="editingAddress = false" />
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import LeftNavigator from '../../components/profile/LeftNavigator'
import Info from '../../components/profile/Info'
import EditDetail from '../../components/profile/EditDetail'
import ChangePassword from '../../components/profile/ChangePassword'
import EditAddress from '../../components/profile/EditAddress'
export default {
  name: 'MyOrders',
  components: {
    'left-nav': LeftNavigator,
    'info': Info,
    'editdetail': EditDetail,
    'change-password': ChangePassword,
    'edit-address': EditAddress
  },
  data () {
    return {
      editingDetail: false,
      changeingPassword: false,
      editingAddress: false,
      editingAddressId: 0
    }
  },
  created () {
    this.$store.dispatch('customer/getCustomerInfo')
  },
  methods: {
    editAddress: function (id) {
      this.editingAddressId = id
      this.editingAddress = true
    }
  },
  computed: {
    ...mapGetters('customer', ['info'])
  }
}
</script>


// WEBPACK FOOTER //
// src/views/profile/Information.vue